__webpack_require__.p = "https://RetailerAdminMFE-stage.shipbob.dev/";